module.exports = __webpack_public_path__ + "images/icons_v2/values-think-big-8ea2e81f.svg";